import { TippyCustomzie } from "components/TippyCustomzie"
import { PATH } from "constants/path"
import { pushTo } from "helpers/history"
import { useBoolean } from "helpers/hooks"
import { formatDate } from "helpers/utils"
import { PendingApprovals } from "pages/conversations/conversations.type"
import BellIcon from "assets/images/icons/bell-icon.svg"
import { OrganizationIconCard } from "components/OrganizationIconCard"
import { getSavedWsCode } from "helpers/wsCode.helper"

interface Props {
    pendingApprovals: PendingApprovals
}
export const PendingApprovalCard = (props: Props) => {
    const { pendingApprovals } = props
    const isPendingApprovalsPopoverOpen = useBoolean(false)
    return (
        <TippyCustomzie
            containerClass="pending-approvals-popover"
            placement="bottom"
            interactive
            arrow={false}
            animation="scale"
            visible={isPendingApprovalsPopoverOpen.value}
            onClickOutside={() => {
                isPendingApprovalsPopoverOpen.setValue(false)
            }}
            allowHTML
            offset={[0, 0]}
            content={
                <div
                    className="bg-white"
                    style={{
                        width: "100%",
                        maxHeight: 500,
                        overflow: "auto",
                        boxShadow: "0px 4px 16px rgba(29, 29, 29, 0.25)",
                    }}
                >
                    <div className="py-[8px]">
                        <div className="flex flex-col gap-3">
                            {pendingApprovals.data.map((approval, index) => {
                                const code = approval.conversation_code || approval.build_code
                                return (
                                    <div
                                        key={approval.id || index}
                                        className="flex flex-col"
                                        style={{
                                            borderBottom:
                                                index === pendingApprovals.data.length - 1
                                                    ? "none"
                                                    : "1px solid #E4E4E4",
                                            padding: "0px 16px 8px 16px",
                                        }}
                                    >
                                        <div className="flex items-center gap-2">
                                            <OrganizationIconCard
                                                name={approval.name || ""}
                                                bg={approval.background_color || ""}
                                                zIndex={1}
                                                icon={approval.logo_url || ""}
                                                organizationId={approval.id || ""}
                                                width={30}
                                                height={30}
                                                className="rounded-[8px] flex items-center justify-center min-w-[30px] max-w-[30px] min-h-[30px] max-h-[30px]"
                                            />
                                            <div className="flex flex-col">
                                                <p
                                                    className="font-semibold mb-[4px]"
                                                    style={{
                                                        color: "#111111",
                                                        fontSize: 14,
                                                        lineHeight: "20px",
                                                    }}
                                                >
                                                    {code}
                                                </p>
                                                <div className="flex items-center gap-2">
                                                    <p className="text-13 leading-22 text-[#7A7A7A]">Requested by <span className="font-semibold text-[#111111]">{approval.user_fullname
                                                    } - {approval.user_email}</span>{` at ${formatDate(
                                                        approval.created_at,
                                                        "DD MMM yyyy - HH:mm A"
                                                    )}`}</p>
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            isPendingApprovalsPopoverOpen.setValue(false)
                                                            if (approval.conversation_id) {
                                                                pushTo(
                                                                    PATH.conversations,
                                                                    undefined,
                                                                    undefined,
                                                                    {
                                                                        conversationId: approval.conversation_id,
                                                                        workspaceId: approval.db_name,
                                                                    }
                                                                )
                                                            } else if (approval.build_id && approval.build_status && approval.project_id) {
                                                                const approvalWsCode = approval.db_name.toUpperCase()
                                                                const savedWsCode = getSavedWsCode()
                                                                const newURL = `/${approvalWsCode}/build/${approval.build_status}/${approval.project_id}/${approval.build_id}?tab=${approval.build_owner ? "my-builds" : "others"}`
                                                                if (savedWsCode && savedWsCode.toUpperCase() !== approvalWsCode) {
                                                                    window.location.href = newURL
                                                                    return
                                                                }
                                                                pushTo(newURL)
                                                            } else {
                                                                const approvalWsCode = approval.db_name.toUpperCase()
                                                                const savedWsCode = getSavedWsCode()
                                                                const newURL = `/${approvalWsCode}/build`
                                                                if (savedWsCode && savedWsCode.toUpperCase() !== approvalWsCode) {
                                                                    window.location.href = newURL
                                                                    return
                                                                }
                                                                pushTo(newURL)
                                                            }

                                                        }}
                                                        style={{
                                                            background: "transparent",
                                                            border: "none",
                                                            padding: 0,
                                                            color: "#E87A16",
                                                            fontSize: 13,
                                                            fontWeight: 600,
                                                            cursor: "pointer",
                                                            textDecoration: "none",
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.textDecoration =
                                                                "underline"
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.textDecoration = "none"
                                                        }}
                                                    >
                                                        [View]
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{
                                            background: 'rgb(247, 247, 247)',
                                            borderRadius: '6px',
                                            marginTop: 8,
                                            padding: 8
                                        }}>
                                            <div
                                                className="text-12 text-[#111111] leading-18 max-h-4 font-normal overflow-hidden text-ellipsis whitespace-nowrap pointer-events-none"
                                                dangerouslySetInnerHTML={{
                                                    __html: approval.content,
                                                }}
                                            ></div>
                                        </div>

                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            }
        >
            <div
                style={{
                    minHeight: 56,
                    flexShrink: 0,
                    position: "relative",
                    overflow: "hidden",
                    background: "#FFFBF7",
                    borderBottom: "1px solid rgb(228, 228, 228)",
                    borderLeft: "3px solid #FF8A00",
                    padding: "6px 24px 6px 15px",

                }}
                className="transition-all duration-300"
            >
                {/* Content */}
                <div className="flex items-center justify-between h-full gap-4 relative z-10">
                    <div className="flex items-center gap-4 flex-1">
                        {/* Bell Icon */}
                        <div
                            style={{
                                background: "rgba(232, 122, 22, 0.1)",
                                borderRadius: "10px",
                                padding: "8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                            }}
                        >
                            <img
                                src={BellIcon}
                                alt="bell"
                                style={{
                                    width: 20,
                                    height: 20,
                                    filter:
                                        "brightness(0) saturate(100%) invert(45%) sepia(95%) saturate(2000%) hue-rotate(10deg) brightness(0.95) contrast(1)",
                                }}
                            />
                        </div>
                        {/* Text Content */}
                        <div className="flex flex-col">
                            <p
                                className="font-semibold"
                                style={{
                                    color: "#E87A16",
                                    fontSize: 15,
                                    lineHeight: "22px",
                                    letterSpacing: "0.1px",
                                }}
                            >
                                ACTION REQUIRED
                            </p>
                            <p
                                className="font-normal"
                                style={{
                                    color: "#666666",
                                    fontSize: 13,
                                    lineHeight: "22px",
                                }}
                            >
                                {pendingApprovals.total}{" "}
                                {pendingApprovals.total === 1 ? "approval" : "approvals"}{" "}
                                need your attention
                            </p>
                        </div>
                    </div>
                    <button
                        onClick={(e) => {
                            e.stopPropagation()
                            isPendingApprovalsPopoverOpen.setValue(!isPendingApprovalsPopoverOpen.value)
                        }}
                        style={{
                            background: "#FFF0E0",
                            border: "1px solid #FFD1A3",
                            borderRadius: "6px",
                            padding: "6px 16px",
                            color: "#E65100",
                            fontSize: 14,
                            fontWeight: 600,
                            lineHeight: "20px",
                            cursor: "pointer",

                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#FFE2C2"
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = "#FFF0E0"
                        }}
                    >
                        Review now
                    </button>
                </div>
            </div>
        </TippyCustomzie>
    )
}